import { queryKeys } from '@query/keys'
import { STALE_TIME } from '@query/queryClient'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { DxTradeAccountTransfersResponse } from '@model/DxTrade.types'

import {
  DEFAULT_CASH_TRANSFERS_QUERY,
  DxtradeCashTransfersQuery,
} from '../utils/DxtradeCashTransfersFields'

export const useDxtradeCashTransfers = (
  accountCode: string,
  query: DxtradeCashTransfersQuery = DEFAULT_CASH_TRANSFERS_QUERY
): {
  data: DxTradeAccountTransfersResponse | undefined
  isLoading: boolean
} => {
  const apiClient = useApiClient(ClientApiClient)

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.trade.dxtrade.cashTransfers(accountCode),
    queryFn: () => apiClient.getDxtradeCashTransfers(accountCode, query),
    enabled: !!accountCode,
    staleTime: STALE_TIME.SEMI_STATIC,
    gcTime: STALE_TIME.SEMI_STATIC,
  })

  return { data, isLoading }
}
